import { FC } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { MEDIA_VALUES } from "./constants";
import MediaItem from "./MediaItem";
import classes from "./index.module.css";

const MediaSlider: FC = () => {
  const sliderSettings = {
    dots: true,
    dotsClass: classes.button__bar,
    className: classes.customCarouselContainer,
    infinite: true,
    speed: 500,
    slidesToShow: 1.3,
    slidesToScroll: 1,
  };

  return (
    <>
      <Slider {...sliderSettings}>
        {MEDIA_VALUES.map(({ id, link, label, img_src, main_img, date }) => (
          <MediaItem
            key={id}
            link={link}
            label={label}
            img_src={img_src}
            main_img={main_img}
            date={date}
          />
        ))}
      </Slider>
    </>
  );
};

export default MediaSlider;
